<template>
    <zen-one
      :showuserinfo="false"
      :crumbs="crumbs"
      title="Sistem Hasil Bersepadu Kedah (iHasil)"
    >
      <z-page title="Butiran Pinjaman Pendidikan" >

      <w-card bg-color="" class="">
        <w-flex justify-center align-center>

              <div class="xs4">
                    <h5 class="fw-semibold m0">No. Fail LBNK :</h5>
                    <div class="fw-normal my1 fs-1"> {{form.no_fail}} </div>
              </div>

              <div class="xs4">
                <h5 class="fw-semibold m0">Tarikh Bayar Balik :</h5>
                <div class="fw-normal my1 fs-1"> {{$zutil.dateformat(form.tarikh_bayar_balik)}} </div>
              </div>

              <div class="xs4">
                    <h5 class="fw-semibold m0">Pinjaman Asal (RM) :</h5>
                    <div class="fw-normal my1 fs-1"> {{$zutil.currency(form.pinjaman_asal)}} </div>
              </div>
        </w-flex>
        <w-flex justify-center align-center>

              <div class="xs4">
                    <h5 class="fw-semibold m0">Nama :</h5>
                    <div class="fw-normal my1 fs-1">{{form.no_id}} | {{form.nama_profil}}</div>
              </div>

              <div class="xs4">
                 <h5 class="fw-semibold m0">Kadar Perkhidmatan (%) :</h5>
                 <div class="fw-normal my1 fs-1"> {{form.kadar_perkhidmatan}} </div>
             </div>

              <div class="xs4">
                    <h5 class="fw-semibold m0">Pinjaman Tambahan (RM) :</h5>
                    <div class="fw-normal my1 fs-1"> {{$zutil.currency(form.pinjaman_tambahan)}} </div>
              </div>
        </w-flex>
        <w-flex justify-center align-center>

              <div class="xs4">
                <h5 class="fw-semibold m0">Pusat Pengajian :</h5>
                    <div class="fw-normal my1 fs-1"> {{form.pusat_pengajian}} </div>
              </div>

              <div class="xs4">
                <h5 class="fw-semibold m0"> Caj Denda Lewat (%) :</h5>
                <div class="fw-normal my1 fs-1"> {{form.caj_denda_lewat}} </div>
              </div>

              <div class="xs4">
                    <h5 class="fw-semibold m0">Jumlah Pinjaman (RM) :</h5>
                    <div class="fw-normal my1 fs-1"> {{$zutil.currency(form.jumlah_pinjaman)}} </div>
              </div>
        </w-flex>
        <w-flex justify-center align-center>

              <div class="xs4">
                <h5 class="fw-semibold m0">Kursus :</h5>
                    <div class="fw-normal my1 fs-1"> {{form.kursus}} </div>
              </div>

              <div class="xs4">
                <!--  <h5 class="fw-semibold m0">Kadar Perkhidmatan (%) :</h5>
                 <div class="fw-normal my1 fs-1"> {{form.kadar_perkhidmatan}} </div> -->
              </div>

              <div class="xs4">
                <h5 class="fw-semibold m0">Pinjaman Dikeluarkan (RM) : </h5>
                <div class="fw-normal my1 fs-1"> {{$zutil.currency(form.pinjaman_dikeluarkan)}} </div>
              </div>
        </w-flex>
        <w-flex justify-center align-center>

              <div class="xs4">
                <h5 class="fw-semibold m0">Tarikh Pengajian :</h5>
                <div class="fw-normal my1 fs-1"> {{$zutil.dateformat(form.tarikh_pengajian)}}</div>
              </div>

              <div class="xs4">
                <!-- <h5 class="fw-semibold m0"> Caj Denda Lewat (%) :</h5>
                <div class="fw-normal my1 fs-1"> {{form.caj_denda_lewat}} </div> -->
              </div>

              <div class="xs4">
                <h5 class="fw-semibold m0">Jumlah Ansuran Bulanan (RM) : </h5>
                <div class="fw-normal my1 fs-1"> {{$zutil.currency(form.jumlah_ansuran_bulanan)}} </div>
              </div>
        </w-flex>
        <w-flex justify-center align-center>

              <div class="xs4">
                <h5 class="fw-semibold m0">Status : </h5>
                <div class="fw-normal my1 fs-1"> {{ form.status_keterangan }} </div>
              </div>

              <div class="xs4">
                <h5 class="fw-semibold m0"> </h5>
                <div class="fw-normal my1 fs-1"> </div>
              </div>

              <div class="xs4">
              <h5 class="fw-semibold m0">
                    Potongan Gaji :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                        <template v-if="form.is_potong_gaji == 1">
                        Ya
                        </template>
                        <template v-else>
                            Tidak
                        </template>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <template v-if="form.lkp_pendidikan_status_id == 1 || form.lkp_pendidikan_status_id == 2">
                        <w-tooltip top>
                          <template #activator="{ on }">
                            <w-icon v-on="on" @click="potongGaji(form)">
                             fal fa-pencil
                            </w-icon>
                          </template>
                          Kemaskini
                        </w-tooltip>
                        </template>
                      </div>
                </div>
        </w-flex>
           
        </w-card>

        <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :width="dialog.width"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title> Potongan Gaji </template>
            <template #default>
                <w-form
                    ref="item"
                    v-model="dialog.valid"
                        v-model:errors-count="dialog.errorsCount"
                    @validate="submitPotongan"
                    @success="success">
                  <w-flex>
                    <div class="xs2">
                        <h5 class="fw-semibold m0">
                            Potongan Gaji :
                        </h5>
                    </div>
                    <div class="xs10">
                      <w-radios v-model="item.is_potong_gaji" :items="potongGajiItem" inline ></w-radios>
                    </div>
                  </w-flex><br>
                  <template v-if="item.is_potong_gaji == 1">     
                  <w-flex>
                    <div class="xs2">
                        <h5 class="fw-semibold m0">
                            Pembayar :
                        </h5>
                    </div><br>
                    <div class="xs10">
                      <w-radios v-model="item.is_peminjam" :items="pembayar" inline @input="jenisPembayar(item)"></w-radios>
                    </div>
                  </w-flex><br>
                  <template v-if="item.is_peminjam == 2">
                  <w-flex>
                    <div class="xs2">
                    <h5 class="fw-semibold m0">
                        Nama:
                    </h5>
                    </div>
                    <div class="xs9">
                        <z-input
                            label="Sila Masukan No Kad Pengenalan | Nama *"
                            name="profil_id"
                            readonly outline
                            @click="profilP()"
                            :validators="[validators.required]"
                        />
                    </div>
                    <div class="xs1">
                        &nbsp;
                        <w-icon @click="addProfil()"
                                >fal fa-plus</w-icon
                            >
                    </div>
                  </w-flex> <br>
                  <w-flex>
                    <div class="xs2">
                    </div>
                    <div class="xs10">
                      <template v-if="item.no_id_lain">
                      {{item.no_id_lain}} | {{item.nama_profil_lain}}
                    </template>
                    </div>
                  </w-flex> <br>
                  <w-flex>
                    <!-- <div class="xs2">
                        <h5 class="fw-semibold m0">
                            Jabatan:
                        </h5>
                    </div>
                    <div class="xs10">
                        <z-lookup
                            :url="service_utiliti + 'lookup/pendidikan_pejabat'"
                            :sort="false"
                            :cache="false"
                            required outline
                            placeholder="Sila Masukan Kod | Nama"
                            v-model="item.pendidikan_pejabat_id_lain"
                            :validators="[validators.required]"
                        />
                        </div> -->
                        <div class="xs2">
                        <h5 class="fw-semibold m0">
                            Agensi:
                        </h5>
                    </div>
                    <div class="xs10">
                        <z-lookup
                            :url="service_utiliti + 'lookup/pendidikan_jabatan'"
                            :sort="false"
                            :cache="false"
                            required outline
                            @pilih="jabsLain(item.pendidikan_jabatan_id_lain)"
                            placeholder="Sila Masukan Kod | Nama"
                            v-model="item.pendidikan_jabatan_id_lain"
                            :validators="[validators.required]"
                        />
                    </div>
                        
                  </w-flex><br>
                  <w-flex>
                   
                         <div class="xs2">
                        <h5 class="fw-semibold m0">
                            Jabatan:
                        </h5>
                    </div>
                    <div class="xs10">
                        <!-- <z-lookup
                            :url="service_utiliti + 'lookup/pendidikan_pejabat'"
                            :sort="false"
                            :cache="false"
                            required outline
                            placeholder="Sila Masukan Kod | Nama"
                            v-model="item.pendidikan_pejabat_id_lain"
                            :validators="[validators.required]"
                        /> -->
                         <template v-if="item.pendidikan_jabatan_id_lain "> 
                      <!-- <w-radios v-model="item.pendidikan_pejabat_id_lain" :items="penjablain" inline ></w-radios> -->
                            <select v-model="item.pendidikan_pejabat_id_lain" class="inline" style="width:650px; height:30px; background-color: white;">
                              <option v-for="option in penjablain" :value="option.value">
                                {{ option.label }}
                              </option>
                            </select>
                    
                    </template>
                        </div>
                        <br>

                      {{item.pendidikan_pejabat_id_lain}}
                  </w-flex> <br>
                  <w-flex>
                    <div class="xs2">
                        <h5 class="fw-semibold m0">
                            Bulan Mula Potongan gaji:
                        </h5>
                    </div>
                    <div class="xs10">
                      <z-lookup name="akaun" outline
                          :url="service_utiliti + 'lookup/bulan'"
                          :sort="false"
                          :cache="false"
                          v-model="item.bulan_lain"
                          :validators="[validators.required]" >
                      </z-lookup>
                    </div>
                  </w-flex><br>
                  <w-flex>
                    <div class="xs2">
                        <h5 class="fw-semibold m0">
                            Tahun :
                        </h5>
                    </div>
                    <div class="xs10">
                       <w-input v-model="item.tahun_lain" required outline 
                            placeholder="Sila Masukan "></w-input>
                    </div>
                  </w-flex><br>
                  <w-flex>
                    <div class="xs2">
                        <h5 class="fw-semibold m0">
                            Kadar Potongan Gaji (RM):
                        </h5>
                    </div>
                    <div class="xs10">
                      <z-money 
                        outline
                        v-model:originalValue="item.amaun_lain"
                        :validators="[validators.required]">
                      </z-money>
                    </div>
                  </w-flex> 
                  </template>
                  <template v-if="item.is_peminjam == 1">
                  <w-flex>
                    <div class="xs2">
                        <h5 class="fw-semibold m0">
                            Nama:
                        </h5>
                    </div>
                    <div class="xs10">
                      {{item.no_id}} | {{item.nama_profil}}
                    </div>
                  </w-flex> <br>
                  <w-flex>
                     <div class="xs2">
                        <h5 class="fw-semibold m0">
                            Agensi:
                        </h5>
                    </div>
                    <div class="xs10">
                        <z-lookup
                            :url="service_utiliti + 'lookup/pendidikan_jabatan'"
                            :sort="false"
                            :cache="false"
                            @pilih="jabs(item.pendidikan_jabatan_id)"
                            required outline
                            placeholder="Sila Masukan Kod | Nama"
                            v-model="item.pendidikan_jabatan_id"
                            :validators="[validators.required]"
                        />
                    </div>
                        <!-- <div class="xs">
                            &nbsp;
                            <w-icon @click="jabatanDialog()"
                                >fal fa-plus</w-icon
                            >
                        </div> -->
                       
                    
                  </w-flex><br>
                  <w-flex>
                        <div class="xs2">
                        <h5 class="fw-semibold m0">
                            Jabatan:
                        </h5>
                    </div>
                    <div class="xs10">
                        <!-- {{penjab}} -->
                    <template v-if="item.pendidikan_jabatan_id "> 
<!--                         <z-lookup
                           :url="service_utiliti + 'lookup/pendidikan_jabatan_detail/'+item.pendidikan_jabatan_id"
                            :sort="false"
                            :cache="false"
                            required outline
                            placeholder="Sila Masukan Kod | Nama"
                            v-model="item.pendidikan_pejabat_id"
                            :validators="[validators.required]"
                        /> -->

                      <!-- <w-radios v-model="item.pendidikan_pejabat_id" :items="penjab" inline ></w-radios> -->

                      <select v-model="item.pendidikan_pejabat_id" class="inline" style="width:810px; height:30px; background-color: white;">
                              <option v-for="option in penjab" :value="option.value">
                                {{ option.label }}
                              </option>
                            </select>
                    
                    </template>
                        </div>
                  </w-flex> <br>
                  <w-flex>
                    <div class="xs2">
                        <h5 class="fw-semibold m0">
                            Bulan Mula Potongan gaji:
                        </h5>
                    </div>
                    <div class="xs10">
                      <z-lookup name="akaun" outline
                          :url="service_utiliti + 'lookup/bulan'"
                          :sort="false"
                          :cache="false"
                          v-model="item.bulan"
                          :validators="[validators.required]" >
                      </z-lookup>
                    </div>
                  </w-flex><br>
                  <w-flex>
                    <div class="xs2">
                        <h5 class="fw-semibold m0">
                            Tahun :
                        </h5>
                    </div>
                    <div class="xs10">
                       <w-input v-model="item.tahun" required outline :validators="[validators.required]"
                            placeholder="Sila Masukan "></w-input>
                    </div>
                  </w-flex><br>
                  <w-flex>
                    <div class="xs2">
                        <h5 class="fw-semibold m0">
                            Kadar Potongan Gaji (RM):
                        </h5>
                    </div>
                    <div class="xs10">
                      <z-money 
                        outline
                        v-model:originalValue="item.amaun"
                        :validators="[validators.required]"
                        >
                      </z-money>
                      <!-- <div class="w-form-el__error error"
                           v-if="form.jumlah_ansuran_bulanan >= 0" style="">Baki Tidak bole kurang
                      </div> -->
                    </div>
                  </w-flex> 
                </template>
                </template>
                </w-form>
            </template>
            <template #actions>
                <div class="spacer" />
                <w-button
                    bg-color="grey-light5--bg"
                    @click="dialog.show = false"
                    >Tutup</w-button
                >
                <w-button v-if="item.is_potong_gaji == 1"
                    class="ml1"
                    :loading="dialog.loading"
                    :disabled="dialog.valid === false"
                    @click="$refs.item.validate()"
                    >Daftar</w-button
                >
                <w-button v-if="item.is_potong_gaji == 0"
                    class="ml1"
                    :loading="dialog.loading"
                    @click="$refs.item.validate()"
                    >Daftar</w-button
                >
            </template>
        </w-dialog>
        <w-dialog
                    v-model="dialogAddProfil.show"
                    :fullscreen="dialogAddProfil.fullscreen"
                    :width="dialogAddProfil.width"
                    :persistent="dialogAddProfil.persistent"
                    :persistent-no-animation="dialogAddProfil.persistentNoAnimation"
                    title-class="primary-light1--bg white"
                >
                    <template #title> Tambah Profil </template>
                    <template #default>
                        <w-form
                            ref="form"
                            v-model="dialogAddProfil.valid"
                            @validate="submitProfil"
                            @success="success"
                        >
                            
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="ID Pengenalan/No. Syarikat*"
                                    name="ID Pengenalan/No. Syarikat*"
                                    v-model="form_profil.no_id"
                                    :validators="[validators.required]"
                                />&nbsp;&nbsp;&nbsp;
                                <z-input
                                    label="Nama*"
                                    name="Nama*"
                                    v-model="form_profil.nama"
                                    :validators="[validators.required]"
                                />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="Alamat"
                                    name="Alamat"
                                    v-model="form_profil.alamat1"
                                    :validators="[validators.required]"
                                />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    name="Alamat"
                                    v-model="form_profil.alamat2"
                                />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    name="Alamat"
                                    v-model="form_profil.alamat3"
                                />
                            </w-flex>
                            <z-lookup
                                label="Poskod"
                                name="poskod"
                                :url="service_deposit + 'lookup/lkp_poskod'"
                                :sort="false"
                                :cache="false"
                                v-model="form_profil.lkp_poskod_id"
                                :validators="[validators.required]"
                            /><br />
                            <w-flex
                                justify-center
                                align-center
                                v-if="form_profil.bandar"
                            >
                                <div class="xs6">
                                    <h5 class="fw-semibold m0">Bandar :</h5>
                                    {{ form_profil.bandar }}
                                </div>

                                <div class="xs6">
                                    <h5 class="fw-semibold m0">Negeri :</h5>
                                    {{ form_profil.negeri }}
                                </div>
                                <br />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="No. Telefon"
                                    name="No. Telefon"
                                    v-model="form_profil.no_tel"
                                    :validators="[validators.numeric]"
                                />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="Email"
                                    name="Email"
                                    v-model="form_profil.emel"
                                    
                                />
                            </w-flex>
                            <div class="title4 mb2">Kategori Profil*</div>
                            <w-radios :items="kategori" 
                                v-model="form_profil.kategori"
                                :sort="false"
                                :cache="false" 
                                :validators="[validators.required]"
                                inline></w-radios>
                        </w-form>
                    </template>
                    <template #actions>
                        <div class="spacer" />
                        <w-button
                            bg-color="grey-light5--bg"
                            @click="dialogAddProfil.show = false"
                            >Tutup</w-button
                        >
                        <w-button
                            class="ml1"
                            :loading="dialog.loading"
                            :disabled="dialogAddProfil.valid === false"
                            @click="$refs.form.validate()"
                            >Daftar</w-button
                        >
                    </template>
                </w-dialog>
        <w-dialog
                v-model="dialogProfil.show"
                :fullscreen="dialogProfil.fullscreen"
                :width="dialogProfil.width"
                :persistent="dialogProfil.persistent"
                :persistent-no-animation="dialogProfil.persistentNoAnimation"
                title-class="primary-light1--bg white"
            >
                <template #title>
                    <w-icon class="mr2">fal fa-user</w-icon>
                    Carian Profil
                </template>
                <div class="page-wrapper-portal">
                    <w-flex justify-center align-center>
                        <div class="xs8">
                            <w-input
                                label="No KP | Nama"
                                v-model="carian_profil.q"
                            >
                            </w-input>
                        </div>
                        <div class="xs4">
                            <w-button class="ml1" @click="cariProfil"
                                >Cari</w-button
                            >
                        </div>
                    </w-flex>
                    <div class="table-profil-scrol">
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No KP | Nama
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        Pilih
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dt, index) in profils">
                                    <td class="w-table__cell text-left">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.label }}
                                    </td>
                                    <td class="w-table__cell text-right">
                                        <w-radio
                                            class="mr2"
                                            v-model="form.profil_id"
                                            :return-value="dt.value"
                                            @click="pilihProfil(dt)"
                                        ></w-radio>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="dialogProfil.show = false"
                        >Tutup</w-button
                    >
                </template>
            </w-dialog>
              <w-dialog
                    v-model="dialogJabatan.show"
                    :fullscreen="dialogJabatan.fullscreen"
                    :width="dialogJabatan.width"
                    :persistent="dialogJabatan.persistent"
                    :persistent-no-animation="dialogJabatan.persistentNoAnimation"
                    title-class="primary-light1--bg white"
                >
                    <template #title> Tambah Agensi </template>
                    <template #default>
                        <w-form
                            ref="form"
                            v-model="dialogJabatan.valid"
                            @validate="submitJabatan"
                            @success="success"
                        >
                            
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="Kod *"
                                    name="Kod *"
                                    v-model="item_jabatan.kod"
                                    :validators="[validators.required]"
                                />&nbsp;&nbsp;&nbsp;
                                <z-input
                                    label="Nama*"
                                    name="Nama*"
                                    v-model="item_jabatan.nama"
                                    :validators="[validators.required]"
                                />
                            </w-flex>
                        </w-form>
                    </template>
                    <template #actions>
                        <div class="spacer" />
                        <w-button
                            bg-color="grey-light5--bg"
                            @click="dialogJabatan.show = false"
                            >Tutup</w-button
                        >
                        <w-button
                            class="ml1"
                            :loading="dialogJabatan.loading"
                            :disabled="dialogJabatan.valid === false"
                            @click="$refs.form.validate()"
                            >Daftar</w-button
                        >
                    </template>
                </w-dialog>

      <!-- <center v-if="loading"><w-progress class="ma1" circle></w-progress></center> -->

      <w-tabs :items="tabs" :no-slider="false" active-class="primary" v-model="activeTab">

        <!-- TAB TRANSAKSI -->
        <template #item-content.1>
          <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button class="ml1" @click="cetak" bg-color="success">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
                    <w-flex justify-center align-center>
                       <div class="w-card__content content-hardcode">
                           <table class="table-dashboard" width="100%">
                               <thead>
                                   <tr>
                                       <th width="5%">Tarikh</th>
                                       <th width="5%">No BR/Resit</th>
                                       <th width="20%">Keterangan</th>
                                       <th width="5%">D.Pokok (RM)</th>
                                       <th width="5%">D.Ansuran Bulanan (RM)</th>
                                       <th width="5%">Debit B.P (RM)</th>
                                       <th width="5%">D.L/lain (RM)</th>
                                       <th width="5%">Kredit Pokok (RM)</th>
                                       <th width="5%">Kredit Ansuran Bulanan (RM)</th>
                                       <th width="5%">Kredit B.P (RM)</th>
                                       <th width="5%">Kredit L/Lain (RM)</th>
                                       <th width="5%">Baki Pokok (RM)</th>
                                       <th width="5%">Baki B.P (RM)</th>
                                       <th width="5%">Baki L/Lain (RM)</th>
                                       <th width="5%">Jumlah Baki (RM)</th>
                                       <th width="10%">Status Resit</th>
                                   </tr>
                               </thead>
                               <tbody>

                                   <tr
                                       v-for="(
                                           dt, index
                                       ) in form.trans"
                                   >
                                       <td>{{dt.tarikh}}</td>
                                       <td>{{dt.no_rujukan}}</td>
                                       <td>{{dt.keterangan}}</td>
                                       <td align="right">
                                            {{ $zutil.currency(dt.d_poko) }}
                                       </td>
                                       <td align="right">
                                            {{ $zutil.currency(dt.d_ansuran) }}
                                       </td>
                                       <td align="right">
                                            {{ $zutil.currency(dt.d_bp) }}
                                       </td>
                                       <td align="right">
                                            {{ $zutil.currency(dt.d_lain) }}
                                       </td>
                                       <td align="right">
                                            {{ $zutil.currency(dt.k_poko) }}
                                       </td>
                                       <td align="right">
                                            {{ $zutil.currency(dt.k_ansuran) }}
                                       </td>
                                       <td align="right">
                                           {{ $zutil.currency(dt.k_bp) }}
                                       </td>
                                       <td align="right">
                                           {{ $zutil.currency(dt.k_lain) }}
                                       </td>
                                       <td align="right">
                                           {{ $zutil.currency(dt.jumlah_poko) }}
                                       </td>
                                       <td align="right">
                                           {{ $zutil.currency(dt.jumlah_bp) }}
                                       </td>
                                       <td align="right">
                                           {{ $zutil.currency(dt.jumlah_lain) }}
                                       </td>
                                       <td align="right">
                                           {{ $zutil.currency(dt.jumlah) }}
                                       </td>
                                       <td>{{dt.resit_status}}</td>
                                   </tr>
                                   <tr>
                                    <td colspan="3">Jumlah Akhir (RM)</td>
                                    <td align="right"><b>{{$zutil.currency(form.jumlah_d_p)}}</b></td>
                                    <td align="right"><b>{{$zutil.currency(form.jumlah_ansuran_d)}}</b></td>
                                    <td align="right"><b>{{$zutil.currency(form.jumlah_d_bp)}}</b></td>
                                    <td align="right"><b>{{$zutil.currency(form.jumlah_d_ll)}}</b></td>
                                    <td align="right"><b>{{$zutil.currency(form.jumlah_k_p)}}</b></td>
                                    <td align="right"><b>{{$zutil.currency(form.jumlah_ansuran_k)}}</b></td>
                                    <td align="right"><b>{{$zutil.currency(form.jumlah_k_bp)}}</b></td>
                                    <td align="right"><b>{{$zutil.currency(form.jumlah_k_ll)}}</b></td>
                                    <td align="right"><b>{{$zutil.currency(form.jumlah_b_p)}}</b></td>
                                    <td align="right"><b>{{$zutil.currency(form.jumlah_b_bp)}}</b></td>
                                    <td align="right"><b>{{$zutil.currency(form.jumlah_b_ll)}}</b></td>
                                    <td align="right"><b>{{$zutil.currency(form.jumlah_b)}}</b></td>
                                    <td align="right"><b></b></td>


                                   <!--  <td>{{$zutil.currency(form.jumlah_d_p)}}</td>
                                    <td></td>
                                    <td>{{$zutil.currency(form.jumlah_d_bp)}}</td>
                                    <td>{{$zutil.currency(form.jumlah_d_ll)}}</td>
                                    <td>{{$zutil.currency(form.jumlah_k_p)}}</td>
                                    <td>{{$zutil.currency(form.jumlah_k_ll)}}</td>
                                    <td>{{$zutil.currency(form.jumlah_d_ll)}}</td> -->
                                   </tr>
                               </tbody>
                           </table>
                       </div>
                   </w-flex>

                    <w-flex class="mt3" wrap align-center justify-end>
                            <w-button
                                class="my1"
                                bg-color="warning"
                                dark
                                @click="back()"
                                >Kembali</w-button
                            >
                        </w-flex>
         </template>

         <!-- TAB BAYARAN BALIK -->
         <template #item-content.2>
                    <w-form
                        class=""
                        v-model="form.valid"
                        v-model:errors-count="form.errorsCount"
                        @validate="onValidate"
                        @success="send"
                    >

                        <w-flex>
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                    Amaun Dikeluarkan (RM) :
                                </h5>
                            </div>
                            <div class="xs10">
                                {{ $zutil.currency(form.pinjaman_dikeluarkan) }}
                            </div>
                        </w-flex>
                            <br />

                        <w-flex>
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                    Amaun Diterima (RM) :
                                </h5>
                            </div>
                            <div class="xs10">
                                {{ $zutil.currency(form.diterima) }}
                            </div>
                        </w-flex>
                            <br />
                        <w-flex>
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                    Amaun Pokok Diterima (RM) :
                                </h5>
                            </div>
                            <div class="xs10">
                                {{ $zutil.currency(form.jumlah_k) }}
                            </div>
                        </w-flex>
                            <br />

                        <w-flex>
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                    Amaun Bayaran Balik (RM) :
                                </h5>
                            </div>
                            <div class="xs10">
                                {{ $zutil.currency(form.bayaran_balik) }}
                            </div>
                        </w-flex>
                        <br />

                        <w-flex>
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                    Amaun Pelarasan (RM) :
                                </h5>
                            </div>
                            <div class="xs10">
                                {{ $zutil.currency(form.pelarasan) }}
                            </div> </w-flex>
                            <br><br>


                        <w-flex>
                            <div class="xs2">
                                <h5 class="fw-semibold m0">Bayaran Ke Pembayar :</h5>
                            </div>
                        </w-flex><br>

                        <w-flex>
                            <div class="xs2">
                                <h5 class="fw-semibold m0">Amaun (RM) *</h5>
                            </div>
                            <div class="xs10">
                                <z-money
                                    outline
                                    :readonly="form.lkp_pendidikan_status_id != 4"
                                    v-model:originalValue="form.amaun_bayar"
                                    v-on:keyup="cekJumlah(form)"
                                    validators="[validators.required]"
                                ></z-money>
                            </div><br/>
                        </w-flex>

                        <w-flex>
                                <div class="xs2"><br/>
                                    <h5 class="fw-semibold m0">Bank * :</h5>
                                </div>
                                <div class="xs10"><br/>
                                <template v-if="form.lkp_pendidikan_status_id == 4">
                                    <z-lookup name="akaun" outline
                                        :url="service_utiliti + 'lookup/bank'"
                                        :sort="false"
                                        :cache="false"
                                        v-model="form.lkp_bank_id"
                                        :validators="[validators.required]" >
                                    </z-lookup>
                                </template>
                                <template v-else>
                                    <z-lookup name="akaun" outline
                                        readonly
                                        :sort="false"
                                        :cache="false"
                                        v-model="form.lkp_bank_id"
                                        :validators="[validators.required]" >
                                    </z-lookup>
                                </template>
                                </div><br/>
                        </w-flex>

                        <w-flex>
                            <div class="xs2"><br/>
                                    <h5 class="fw-semibold m0">No Akaun Bank * :</h5>
                                </div>
                                <div class="xs10"><br/>
                                    <w-input
                                        :readonly="form.lkp_pendidikan_status_id != 4"
                                        v-model="form.no_akaun"
                                        required outline
                                        placeholder="Sila Masukan No Akaun Bank"
                                        :validators="[validators.required]">
                                    </w-input>
                            </div>
                        </w-flex><br>

                        <!-- <w-flex>
                            <div class="xs2"><br/>
                                <h5 class="fw-semibold m0">Baki Akhir (RM) :</h5>
                            </div>
                            <template v-if="form.amaun_bayar == null">
                            <div class="xs10"><br/>
                                {{ $zutil.currency(form.baki_akhir) }}
                            </div>
                          </template>
                          <template v-else>
                            <div class="xs10"><br/>
                                {{ $zutil.currency(form.baki_akhirr) }}
                            </div>
                          </template>
                        </w-flex><br> -->
                        <template v-if="form.lkp_pendidikan_status_id != 4">
                          <w-flex>
                            <div class="xs2"><br/>
                                <h5 class="fw-semibold m0">Baki Akhir (RM) :</h5>
                            </div>
                            <div class="xs10"><br/>
                                0.00
                            </div>
                        </w-flex><br>
                        </template>
                        <template v-else>
                          <w-flex>
                            <div class="xs2"><br/>
                                <h5 class="fw-semibold m0">Baki Akhir (RM) :</h5>
                            </div>
                            <template v-if="form.amaun_bayar == null">
                            <div class="xs10"><br/>
                                {{ $zutil.currency(form.baki_akhir) }}
                            </div>
                          </template>
                          <template v-else>
                            <div class="xs10"><br/>
                                {{ $zutil.currency(form.baki_akhirr) }}
                            </div>
                          </template>
                        </w-flex><br>
                        </template>

                        <w-flex>
                            <div class="xs2"><br/>
                                <h5 class="fw-semibold m0">Keterangan * :</h5>
                            </div>
                            <div class="xs10"><br/>
                                <w-textarea
                                   :readonly="form.lkp_pendidikan_status_id != 4"
                                    class="mb3"
                                    label-position="left"
                                    outline
                                    v-model="form.keterangan_bayaran"
                                    :validators="[validators.required]"
                                >
                                </w-textarea>
                            </div>
                        </w-flex>

                        <w-flex>
                            <div class="xs2"><br/>
                                <h5 class="fw-semibold m0">Dokumen sokongan :</h5>
                            </div>
                            <div class="xs10"><br>
                                <a>
                                {{form.lampiran_fail}}

                                </a>
                                <br>
                                <template v-if="form.lkp_pendidikan_status_id == 4">
                                  <w-input
                                    class="mt3"
                                    outline
                                    type="file"
                                    v-model="files"
                                >
                                </w-input>
                                </template>
                                <template v-else>
                                <w-input
                                    readonly
                                    class="mt3"
                                    outline
                                >
                                </w-input>
                                </template>
                            </div>
                        </w-flex><br/>
                        <template v-if="form.no_bayaran != null">
                        <w-flex>
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                    No Bayaran :
                                </h5>
                            </div>
                            <div class="xs10">
                                {{ form.no_bayaran}}
                            </div>
                        </w-flex><br>
                        <w-flex>
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                    Status :
                                </h5>
                            </div>
                            <div class="xs10">
                                {{ form.status_bayaran}}
                            </div>
                        </w-flex>
                      </template>

                        <w-flex class="mt3" wrap align-center justify-end>
                            <w-button class="my1"
                                bg-color="warning" dark
                                @click="back()" >Kembali</w-button>
                            &nbsp;&nbsp;
                            <w-button class="mr2"
                                bg-color="warning"
                                type="reset" @click="clear()">Reset
                            </w-button>

                        <template v-if="form.no_bayaran == null && form.lkp_pendidikan_status_id == 4">
                            <w-button
                                class="my1" type="submit"
                                :disabled="form.valid === false"
                                @click="send(1)">
                                <!-- <w-icon dark tile class="mr2" >fal fa-paper-plane</w-icon> -->
                                Hantar
                            </w-button>
                        </template>
                        <template v-else-if="form.no_bayaran != null && form.lkp_pendidikan_status_id == 4">
                            <w-button
                                class="my1" type="submit"
                                :disabled="form.valid === false"
                                @click="send(2)">
                                <!-- <w-icon dark tile class="mr2" >fal fa-paper-plane</w-icon> -->
                                Simpan
                            </w-button>
                            &nbsp;&nbsp;
                            <w-button
                                class="my1" type="submit"
                                :disabled="form.valid === false"
                                @click="send(3)">
                                <!-- <w-icon dark tile class="mr2" >fal fa-paper-plane</w-icon> -->
                                Lulus
                            </w-button>
                        </template>
                        <template v-else>
                            <w-button
                                class="my1" :disabled="true">
                                <w-icon dark tile class="mr2" >fal fa-paper-plane</w-icon>
                                    Hantar
                                </w-button>
                        </template>
                        </w-flex>
                    </w-form>
        </template>

        <template #item-content.3>
          <template v-if="form.pendidikanPotongan == 0">
            
          <w-flex justify-center align-center>
            <h4>Tiada Maklumat Dipaparkan</h4>
          </w-flex>
          </template>
          <template v-else>
            
          <w-flex justify-center align-center>
              <div class="xs2">
                  <h5 class="fw-semibold m0">
                      Nama : 
                  </h5>
              </div>
              <div class="xs10">
                 {{form.pendidikanPotongan.nama_profil}} 
              </div>
          </w-flex><br>
          <w-flex justify-center align-center>
              <div class="xs2">
                  <h5 class="fw-semibold m0">
                      Agensi:
                  </h5>
              </div>
              <div class="xs10">
                 {{form.pendidikanPotongan.agensi}} 
              </div>
          </w-flex><br>
          <w-flex justify-center align-center>
              <div class="xs2">
                  <h5 class="fw-semibold m0">
                      Jabatan:
                  </h5>
              </div>
              <div class="xs10">
                 {{form.pendidikanPotongan.jabatan}} 
              </div>
          </w-flex><br>
          <w-flex justify-center align-center>
              <div class="xs2">
                  <h5 class="fw-semibold m0">
                      Bulan Mula:
                  </h5>
              </div>
              <div class="xs10">
                 {{form.pendidikanPotongan.bulan}} | {{form.pendidikanPotongan.tahun}}
              </div>
          </w-flex><br>
          <w-flex justify-center align-center>
              <div class="xs2">
                  <h5 class="fw-semibold m0">
                      Kadar Potongan (RM):
                  </h5>
              </div>
              <div class="xs10">
                 {{ $zutil.currency(form.pendidikanPotongan.amaun)}}
              </div>
          </w-flex><br>
          </template>
          <w-flex class="mt3" wrap align-center justify-end>
              <w-button
                  class="my1"
                  bg-color="warning"
                  dark
                  @click="back()"
                  >Kembali</w-button
              >
          </w-flex>
        </template>
        <!-- TAB JEJAK AUDIT -->
        <template #item-content.4>

                    <w-flex justify-center align-center>
                        <div class="w-card__content content-hardcode">
                            <table class="table-dashboard" width="100%">
                                <thead>
                                    <tr>
                                        <td width="2%">No</td>
                                        <td width="15%">Tarikh</td>
                                        <td>Pengguna</td>
                                        <td>Status</td>
                                        <td>Catatan</td>
                                    </tr>
                                </thead>
                                <tbody>
                                        <tr v-for="(dt, index) in form.jejak_audit">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ dt.tarikh }}</td>
                                            <td>{{ dt.user_nama }}</td>
                                            <td>
                                                {{ dt.tindakan_keterangan }}
                                            </td>
                                            <td>{{ dt.catatan }}</td>
                                        </tr>
                                        <tr v-if="form.jejak_audit.length == 0">
                                            <td></td>
                                        </tr>
                                    </tbody>
                            </table>
                        </div>
                    </w-flex>
                    <w-flex class="mt3" wrap align-center justify-end>
                        <w-button
                            class="my1"
                            bg-color="warning"
                            dark
                            @click="back()"
                            >Kembali</w-button
                        >
                    </w-flex>

        </template>

      </w-tabs>
      </z-page>
    </zen-one>
  </template>

  <script>

  import ZResource from '@/Modules/z-resource-service'

  export default {
    extends: ZResource,
    components: {},
    props: {
        id: [Array, Object, String],

    },
    data() {
      return {

        dialog: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
        },
        dialogJabatan: {
            valid: false,
            show: false,
            fullscreen: false,
            persistent: true,
            persistentNoAnimation: false,
            loading: false,
            width: 800,
            form: { nama: "", email: "" },
        },
        dialogJabatan: {
            valid: false,
            show: false,
            fullscreen: false,
            persistent: true,
            persistentNoAnimation: false,
            loading: false,
            width: 800,
            form: { nama: "", email: "" },
        },
        dialogAddProfil: {
            valid: false,
            show: false,
            fullscreen: false,
            persistent: true,
            persistentNoAnimation: false,
            loading: false,
            width: 800,
            form: { nama: "", email: "" },
        },
        item: {
            id: 0,
            pendidikan_pejabat_id_lain: '',
            profil_id_lain: '',
            pendidikan_jabatan_id_lain: '',
            tahun_lain: '',
            bulan_lain: '',
            pendidikan_pejabat_id: '',
            profil: '',
            pendidikan_jabatan_id: '',
            tahun: '',
            bulan: '',
            is_peminjam: '',
        },
        form_profil: {},
        kategori_items: [
        {label : 'CEMERLANG', value : '1'},
        {label : 'SEDERHANA', value : '2'},
        {label : 'LEMAH', value : '3'}
        ],
        penjab: [], 
        penjablain: [],      
        kategori: [
            {
                value: 1,
                label: "Individu",
            },
            {
                value: 2,
                label: "Syarikat",
            },
        ],
        potongGajiItem: [
                {
                    value: 1,
                    label: "Ya",
                },
                {
                    value: 0,
                    label: "Tidak",
                },
            ],
        pembayar: [
                {
                    value: 1,
                    label: "Peminjam",
                },
                {
                    value: 2,
                    label: "Pembayar Lain - lain",
                },
            ],
        form_cari: {},
        item_jabatan: {},
        jabatan :[],
        form : {
            valid: null,
            submitted: false,
            sent: false,
            errorsCount: 0,
            loading: false,
        },

        i_ind : null,
            id : null,
            carian_profil : {q: ''},
            profils : [],
            dialogProfil: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 800,
                form: {nama: '', email: ''}
            },

      resourceurl: this.service_tunggakan+"pendidikan",
      reload: true,
      activeTab : 0,
      loading: true,

        tabs: [
            { title: 'Transaksi', content: "" },
            { title: 'Bayaran Balik Lebihan', content: "" },
            { title: 'Potongan Gaji', content: "" },
            { title: 'Jejak Audit', content: "" },
        ],
        crumbs: [
          { label: 'iHasil', route: '/ihasil' },
          { label: 'Pendidikan', route: '/pendidikan' },
          { label: 'Papar', route: '/pendidikan'+this.id },
        ],
      }
    },
      methods: {

        clear () {
        this.getData()
            this.files = false
            this.$nextTick(() => {
            this.files = true
            })
        },
      cetak(td)
      {
            window.location.href = this.service_tunggakan+'pendidikan/trans-cetak/'+this.id;
      },

      removeItem(index) {
          this.form.butiran.splice(index, 1);
      },

      potongGaji(form) {
        if (this.form.pendidikanPotongan == 0) {
          this.item.profil_id = this.form.profil_id;
          this.item.nama_profil = this.form.nama_profil;
          this.item.no_id = this.form.no_id; 
          this.item.is_potong_gaji = this.form.is_potong_gaji;
          this.item.pendidikan_pejabat_id = this.form.pendidikan_pejabat.id;
          this.item.pendidikan_jabatan_id = this.form.pendidikan_pejabat.pendidikan_jabatan_id;
          this.item.amaun = this.form.jumlah_ansuran_bulanan;
          this.item.amaun_lain = this.form.jumlah_ansuran_bulanan;
          this.dialog.show = 1;
        } else {
          if (this.form.pendidikanPotongan.is_peminjam == 1)
            {
              this.item.profil_id = this.form.profil_id;
              this.item.nama_profil = this.form.nama_profil;
              this.item.no_id = this.form.no_id; 
              this.item.pendidikan_pejabat_id = this.form.pendidikan_pejabat.id;
              this.item.pendidikan_jabatan_id = this.form.pendidikan_pejabat.pendidikan_jabatan_id;
              this.item.tahun = this.form.pendidikanPotongan.tahun;
              this.item.bulan = this.form.pendidikanPotongan.bulan;
              this.item.amaun = this.form.pendidikanPotongan.amaun;
              this.item.is_potong_gaji = this.form.is_potong_gaji;
              this.item.is_peminjam = this.form.pendidikanPotongan.is_peminjam;
              this.dialog.show = 1;
            } else {
              this.item.profil_id_lain = this.form.pendidikanPotongan.profil_id;
              this.item.pendidikan_pejabat_id_lain = this.form.pendidikan_pejabat.id;
              this.item.pendidikan_jabatan_id_lain = this.form.pendidikan_pejabat.pendidikan_jabatan_id;
              this.item.tahun_lain = this.form.pendidikanPotongan.tahun;
              this.item.bulan_lain = this.form.pendidikanPotongan.bulan;
              this.item.amaun_lain = this.form.pendidikanPotongan.amaun;
              this.item.is_potong_gaji = this.form.is_potong_gaji;
              this.item.no_id_lain = this.form.pendidikanPotongan.profil.no_id;
              this.item.nama_profil_lain = this.form.pendidikanPotongan.profil.nama;
              this.item.is_peminjam = this.form.pendidikanPotongan.is_peminjam;
              this.item.profil_id = this.form.profil_id;
              this.item.nama_profil = this.form.nama_profil;
              this.item.amaun = this.form.pendidikanPotongan.amaun;
              this.item.no_id = this.form.no_id; 
              this.dialog.show = 1;
            }
        }
      },
      jabatanDialog(form) {
            this.dialogJabatan.show = 1;
      },

      agensi() {
          this.dialogAgensi.show = 1;
      },
      back() {
            window.history.back();
      },

      send(tindakan) {
          if(this.form.valid == true){
            this.form.tindakan = tindakan;
            this.$zcomm
                .update(
                    this.resourceurl + "/" + this.form.id,
                    this.form.id,
                    this.form,
                    this.tindakan
                )
                .then((res) => {
                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit();
                    }

                    // this.getData();
                    this.activeTab=1;
                    // this.submitLoading=true;
                    // this.$inertia.visit(this.$route('pendidikan.index'));
                    this.upload(res.id);

                })
                .catch((err) => {})
                .finally(() => {
                        this.form.loading = false
                });
              }
        },
        upload(id) {
            let formData = new FormData();
            formData.append("file", this.files[0].file);
            formData.append("model", "App\\Models\\Pendidikan");
            formData.append("model_id", id);
            this.$zcomm
                .post(this.resourceurl + "/upload", formData)
                .then((res) => {
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.$zutil.notify("Rekod telah berjaya dihantar");

                    // this.getData();
                    this.activeTab=1;
                    // this.submitLoading=true;
                    // this.$inertia.visit(this.$route('pendidikan.index'));
                })
                .catch((err) => {})
                .finally(() => {});
        },

        totalBayaran(form) {
                form.baki_akhir = form.baki_akhir - form.amaun_bayaran;
        },
        cekJumlah(form){
          var bayar = form.amaun_bayar;
          this.cekAmaun(bayar);

        },
        cekAmaun(bayar){
          var baki = this.form.baki_akhir;

          this.form.baki_akhirr = parseFloat(baki) + parseFloat(bayar);

        },
        profilP() {
            this.dialogProfil.show = 1;
        },
        cariProfil() {
            if (this.carian_profil.q.length > 1) {
                this.$zcomm
                    .post(
                        this.service_utiliti + "lookup/profil",
                        this.carian_profil,
                        {}
                    )
                    .then((res) => {
                        console.log(res);
                        this.profils = res;
                    });
            }
        },
        addProfil(dt) {
            this.dialogAddProfil.show = 1;
        },
        pilihProfil(dt) {
            this.form_cari.id = dt.value;
            this.profilDetail();
        },
        profilDetail() {
            this.$zcomm
                .get(this.service_deposit + "profil/" + this.form_cari.id)
                .then((res) => {
                    this.item.profil_id_lain = res.id;
                    this.item.no_id_lain = res.no_id;
                    this.item.nama_profil_lain = res.nama;
                });
        },
        jabatanDetail() {
            this.$zcomm
                .get(this.service_tunggakan + "pendidikanJabatan/" + this.form_cari.id)
                .then((res) => {
                    this.item.kod = res.kod;
                    this.item.nama = res.nama;
                    this.dialogAgensi.show = false;
                });
        },
        submitJabatan() {
            this.dialogJabatan.loading = true;

            this.$zcomm
                .post(this.service_tunggakan + "pendidikanJabatan", this.item_jabatan)
                .then((res) => {
                    this.mapreturneddata(res);
                    this.dialog.show = false;
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.item.nama = res.nama;
                    this.item.kod = res.kod;
                    // this.$inertia.visit(this.$page.url)
                })
                .finally(() => {
                    this.dialogJabatan.loading = false;

                    // $('#' + this.resourceurl).modal('hide')
                });

            // }
        },
        submitPotongan() {

            this.dialog.loading = true;
            if (this.item.is_peminjam == 1 &&this.item.pendidikan_pejabat_id != 0 && this.item.bulan != null && this.item.tahun != null && this.item.amaun != 0) {
              if (this.item.amaun >= this.form.jumlah_ansuran_bulanan) {
                this.dialog.valid = true;
              }else{
                alert('Amaun Kurang');
                this.dialog.valid = false;
              }
            }
            if (this.item.is_peminjam == 2 &&this.item.pendidikan_pejabat_id_lain != 0 && this.item.bulan_lain != null && this.item.tahun_lain != null && this.item.amaun_lain != 0) {
              if (this.item.amaun_lain >= this.form.jumlah_ansuran_bulanan) {
                this.dialog.valid = true;
              }else{
                alert('Amaun Kurang');
                this.dialog.valid = false;
              }
            }
            // alert(this.dialog.valid);
          if(this.dialog.valid == true){
              if (this.item.is_peminjam ==1) {
                  var param = {
                      id : this.form.id,
                      bulan : this.item.bulan,
                      tahun : this.item.tahun,
                      amaun : this.item.amaun,
                      profil_id : this.item.profil_id,
                      is_peminjam : this.item.is_peminjam,
                      is_potong_gaji : this.item.is_potong_gaji,
                      pendidikan_jabatan_id : this.item.pendidikan_jabatan,
                      pendidikan_pejabat_id : this.item.pendidikan_pejabat_id,
                    }
              } else {
                  var param = {
                      id : this.form.id,
                      bulan : this.item.bulan_lain,
                      tahun : this.item.tahun_lain,
                      amaun : this.item.amaun_lain,
                      is_peminjam : this.item.is_peminjam,
                      profil_id : this.item.profil_id_lain,
                      is_potong_gaji : this.item.is_potong_gaji,
                      pendidikan_jabatan_id : this.item.pendidikan_jabatan_lain,
                      pendidikan_pejabat_id : this.item.pendidikan_pejabat_id_lain,
                    }
              }
            this.$zcomm
                .post(this.service_tunggakan + "pendidikan/potongan-gaji/" +
                    this.form.id, param)
                .then((res) => {
                    this.mapreturneddata(res);
                    this.$inertia.reload();
                    this.dialog.show = false;
                    this.dialog.loading = false;
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                })
                .finally(() => {
                    this.$zutil.notify("Rekod Telah Berjaya Disimpan");
                    this.activeTab=2;
                    this.$inertia.reload();
                    this.dialog.loading = false;
                });

                this.getData();

            }
        },
        submitProfil() {
            // if (this.$refs.form.validate()) {
            this.dialog.loading = true;

            this.$zcomm
                .post(this.service_deposit + "profil", this.form_profil)
                .then((res) => {
                    // console.log(res)
                    //update displayed record
                    // this.$page.flash.success = "Rekod telah ditambah"
                    this.mapreturneddata(res);
                    this.dialog.show = false;
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.form.profil_id = res.id;
                    this.form.kategori = res.kategori;
                    this.form.no_id = res.no_id;
                    this.form.nama = res.nama;
                    this.form.alamat1 = res.alamat1;
                    this.form.alamat2 = res.alamat2;
                    this.form.alamat3 = res.alamat3;
                    this.form.poskod = res.poskod;
                    this.form.bandar = res.bandar;
                    this.form.negeri = res.negeri;
                    this.form.keterangan = res.keterangan;
                    this.form.aras_akhir = res.aras_akhir;
                    // this.$inertia.visit(this.$page.url)
                })
                .finally(() => {
                    this.dialog.loading = false;

                    // $('#' + this.resourceurl).modal('hide')
                });

            // }
        },
        //  pejabatDetail() {
      
        // this.$zcomm.get(this.service_utiliti+'lookup/pejabat_detail/'+this.form.perumahan_pejabat_id).then(res => {
        //           this.form.jabatan_keterangan = res.jabatan_keterangan;
        //           this.form.perumahan_jabatan_id = res.perumahan_jabatan_id;
        //         });
        // },

        // jabatanDetail() {
          
        // this.$zcomm.get(this.service_utiliti+'lookup/pendidikan_jabatan_detail/'+this.item.pendidikan_jabatan_id)
        //     .then(res => {
        //             // alert(res.id);
        //                 this.item.pendidikan_pejabat_id = res.id;
        //         });
        // },

        pejabatDetail1() {
            this.$zcomm
                .get(
                    this.service_utiliti +
                        "lookup/lkp_pendidikan_pejabat/" +
                        this.item.pendidikan_pejabat_id
                )
                .then((res) => {
                    this.item.pendidikan_jabatan = res.pendidikan_jabatan_id;
                    this.item.pendidikan_jabatan_id = res.pejabat;
                    // this.form.bandar = res.bandar;
                    // this.form.lkp_jenis_alamat_id = 1;
                    // this.form.jabatan_id = 1;
                });
        },
        pejabatDetail() {
            this.$zcomm
                .get(
                    this.service_utiliti +
                        "lookup/lkp_pendidikan_pejabat/" +
                        this.item.pendidikan_pejabat_id_lain
                )
                .then((res) => {
                    this.item.pendidikan_jabatan_lain = res.pendidikan_jabatan_id;
                    this.item.pendidikan_jabatan_id_lain = res.pejabat;
                    // this.form.bandar = res.bandar;
                    // this.form.lkp_jenis_alamat_id = 1;
                    // this.form.jabatan_id = 1;
                });
        },

        poskodDetail() {
            this.$zcomm
                .get(
                    this.service_deposit +
                        "lookup/lkp_poskod_detail/" +
                        this.form_profil.lkp_poskod_id
                )
                .then((res) => {
                    this.form_profil.negeri = res.negeri;
                    this.form_profil.lkp_negeri_id = res.lkp_negeri_id;
                    this.form_profil.bandar = res.bandar;
                    this.form_profil.lkp_jenis_alamat_id = 1;
                    this.form_profil.jabatan_id = 1;
                });
        },

         getAgensi() {
            this.$zcomm.get(this.service_utiliti+'lookup/pendidikan_jabatan').then(res => {
                  this.penagensi = res;
                });
        },
        

         jabs(id){
           
            this.penjab =[];
            this.$zcomm.get(this.service_utiliti+'lookup/pendidikan_jabatan_detail/'+id).then(res => {
                  this.penjab = res;
                });
            
            },

        jabsLain(id){
           
            this.penjablain =[];
            this.$zcomm.get(this.service_utiliti+'lookup/pendidikan_jabatan_detail/'+id).then(res => {
                  this.penjablain = res;
                });
            
            },

     getData()  {
          var app = this;

          if(this.id){
            if(this.id > 0){
              this.$zcomm.get(this.service_tunggakan +'pendidikan/'+this.id+''+window.location.search).then(res => {
                this.form = res;

              })
              .finally(() => {

                this.loading = false
              });
            }
          }
          
          
        },







    },
    watch: {
        files: function (val) {
            // console.log(val);
            console.log("work");
        },
        "form_cari.id": function (q) {
            // this.jabatanDetail();
            // this.pejabatDetail1();
            this.poskodDetail();
        },
        "form_profil.lkp_poskod_id": function (q) {
            this.poskodDetail();
        },
        // "item.pendidikan_pejabat_id": function (q) {
        //     this.pejabatDetail1();
        // },
        // "item.pendidikan_pejabat_id_lain": function (q) {
        //     this.pejabatDetail();
        // },
        // "item.pendidikan_jabatan_id": function (q) {
        //     this.jabatanDetail();
        // },

    },
    mounted() {
      this.cekAmaun();
      this.getData();
        this.getAgensi();


    },

  }
  </script>
